import BrandView from './components/BrandView';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import has from 'lodash/has';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
  loadBrand
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  const brandId = props.match.params.brandId;

  return {
    brandId:brandId,
    needsLoading:!has(state,['entities','companies',brandId,'name']),
    name:get(state,['entities','companies',brandId,'name']),
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ loadBrand },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(BrandView));



// WEBPACK FOOTER //
// ./src/routes/BrandView/index.js